import { motion } from 'framer-motion';

const voices = [
  {
    quote:
      'Scorpion structured an equipment financing package for our new fleet in five days. Their principal understood our operating cycle immediately — no back-and-forth, no committee.',
    name: 'Priya Rangan',
    title: 'Managing Partner, Halcyon Holdings',
    amount: '$4.2M · Equipment Financing',
  },
  {
    quote:
      'They funded us into peak season when our bank froze the line. Same principal called me back in 40 minutes. That is the difference.',
    name: 'Diego Marín',
    title: 'CEO, Nortec Logistics',
    amount: '$850K · Merchant Cash Advance',
  },
  {
    quote:
      'Invoice factoring set up in 48 hours, drawn against receivables the same week. We have taken three tranches — never once a friction point.',
    name: 'Elena Voss',
    title: 'Founder, Voss Aesthetics',
    amount: '$1.6M · Invoice Factoring',
  },
];

export default function Testimonials() {
  return (
    <section
      id="voices"
      className="relative bg-[#0a0a0a] py-28 lg:py-40 border-y border-[#c2a978]/10 overflow-hidden"
      data-testid="testimonials-section"
    >
      {/* Ambient glow */}
      <div
        className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full blur-3xl opacity-20 pointer-events-none"
        style={{ background: 'radial-gradient(circle, #c2a978 0%, transparent 70%)' }}
      />
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-20 lg:mb-28">
          <div className="lg:col-span-4 flex items-start gap-4">
            <span className="w-10 h-px bg-[#c2a978] mt-3" />
            <span className="text-[10px] tracking-[0.5em] uppercase text-[#c2a978]">
              Ch. 04 — Voices
            </span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="lg:col-span-8 font-serif text-3xl lg:text-5xl leading-[0.95] tracking-[-0.02em]"
          >
            The operators<br />
            we <span className="italic text-[#c2a978]">stand behind</span>.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {voices.map((v, i) => (
            <motion.figure
              key={v.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="relative p-8 lg:p-10 border border-[#c2a978]/15 bg-[#050505] hover:border-[#c2a978]/40 transition-colors duration-500 flex flex-col justify-between min-h-[380px]"
              data-testid={`testimonial-${i}`}
            >
              <span className="absolute -top-4 left-8 font-serif italic text-[#c2a978] text-6xl leading-none">
                “
              </span>
              <blockquote className="font-serif text-lg lg:text-xl text-[#f5f5f0] leading-snug italic pt-6">
                {v.quote}
              </blockquote>
              <figcaption className="mt-10 pt-6 border-t border-[#c2a978]/10">
                <div className="text-sm text-[#f5f5f0]">{v.name}</div>
                <div className="text-[11px] tracking-[0.2em] uppercase text-[#8a8a8a] mt-1">
                  {v.title}
                </div>
                <div className="mt-4 text-[10px] tracking-[0.3em] uppercase text-[#c2a978]">
                  {v.amount}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
